import script from "./EcommerceBrands.vue?vue&type=script&setup=true&lang=js"
export * from "./EcommerceBrands.vue?vue&type=script&setup=true&lang=js"

import "./EcommerceBrands.vue?vue&type=style&index=0&id=269a252c&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\unensecommerce\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-269a252c"]])

export default __exports__